import { render, staticRenderFns } from "./backfill-add.vue?vue&type=template&id=5b076c4a&scoped=true&"
import script from "./backfill-add.vue?vue&type=script&lang=js&"
export * from "./backfill-add.vue?vue&type=script&lang=js&"
import style0 from "./backfill-add.vue?vue&type=style&index=0&id=5b076c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b076c4a",
  null
  
)

export default component.exports